import { ProjectionType } from '@/types/api.generated';

export type PickTypesEducationTarget = {
    projectionType: ProjectionType;
    /** SPECIAL projections cover two tabs (discount/surge); the direction picks the right one. */
    specialIncreased?: boolean;
};

/**
 * Key used to match a tapped pick type against the `projection_types` field of a
 * Prismic pick type item (comma-separated list of these tokens).
 */
export const getPickTypeEducationKey = ({ projectionType, specialIncreased }: PickTypesEducationTarget): string => {
    if (projectionType === ProjectionType.Special) {
        return specialIncreased ? 'SPECIAL_INCREASED' : 'SPECIAL_DECREASED';
    }
    return projectionType;
};

export const pickTypeMatchesEducationKey = (projectionTypes: string | null | undefined, key: string): boolean =>
    !!projectionTypes
        ?.split(',')
        .map(token => token.trim().toUpperCase())
        .includes(key);
